module.exports = __webpack_public_path__ + "img/intro_final.4079f06d.jpg";